var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("action-sheet", {
        staticClass: "action-sheet",
        attrs: {
          opened: _vm.opened,
          title: "MCOM-0000076",
          confirm: "MCOM-0000077",
          cancel: "MCOM-0000078"
        },
        on: {
          "update:opened": function($event) {
            _vm.opened = $event
          },
          confirm: _vm.otpOpen
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("approval-certification", {
                  ref: "approval",
                  attrs: { "corp-bzwk-cd": _vm.corpBzwkCd }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("suppl-certn", {
        ref: "supplCertn",
        attrs: {
          NOS_INSTANCE_REFERANCE: _vm.NOS_INSTANCE_REFERANCE,
          scurtyDeviVndrDstcd: this.scurtyDeviVndrDstcd
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }